import {
  INITIAL_STATE
} from '../state'
import tipoResposta from '../../config/TipoResposta';
const formularioMutation = {
  HABILITAR_VERIFICACAO_RESPOSTA: (state, payload) => {
    state.verificacaoRespostaHabilitado = payload;
  },
  CARREGAR_INFORMACAO_PARTICIPANTE: (state, payload) => {
    state.participante = payload
  },
  ADD_PERGUNTA_SESSAO: (state, payload) => {

    const {
      formulario
    } = state;
    const {
      sessoesFormulario
    } = formulario;
    const [sessao] = sessoesFormulario.filter(s => s.id == 4);
    const pergunta = sessao.perguntas[0];
    const novaPergunta = {
      ...pergunta
    };
    novaPergunta.ordemExibicao += 1;
    sessao.perguntas.push(novaPergunta);
    state.formulario = formulario;

  },
  LIMPAR_FORMULARIO: (state, payload) => {
    for (var propriedade in INITIAL_STATE) {
      if (propriedade) {
        state[propriedade] = INITIAL_STATE[propriedade]
      }
    }
  },
  DEFINIR_FORMULARIO_COMO_ASSISTIDO: (state, payload) => {
    state.formularioAssistido = payload;
  },
  LOAD_FORMULARIO: (state, payload) => {
    // contar a qtd de perguntas
    if(state.isDebug)
      console.log('LOAD_FORMULARIO')


    const formulario = {
      ...payload
    };
    const {
      sessoesFormulario
    } = formulario


    if (sessoesFormulario && sessoesFormulario.length) {
      let novaOrdemPergunta = 1;
      for (let sessao of sessoesFormulario) {
        // perguntas.push(sessao.perguntas)
        const perguntas = sessao.perguntas.sort((a, b) => a.ordemExibicao - b.ordemExibicao);
        for (let pergunta of perguntas) {
          if (pergunta.visivel) {
            pergunta.ordemExibicao = novaOrdemPergunta;
            novaOrdemPergunta++;
          }
        }
      }

      // formulario.sessoesFormulario = {...sessoesFormulario}
    }


    let total = 0
    if (sessoesFormulario) {

      sessoesFormulario.forEach(sessao => {
        total += sessao.perguntas.length
      })
    }

    state.totalPerguntas = total
    state.formulario = formulario;

  },
  RESPONDER_PERGUNTA: (state, payload) => {
    //payload.pergunta
    //payload.respostaPergunta
    //recuperar perguntas respondias
    const {
      perguntasRespondidas
    } = state;
    const {
      opcaoResposta,
      pergunta
    } = payload;
    const {
      sessaoFormularioPerguntaId
    } = pergunta;
    const {
      opcaoRespostaId,
      restritiva,
      perguntaId,
      valor,
    } = opcaoResposta
    let perguntasRespondidasNew = (perguntasRespondidas && perguntasRespondidas.length > 0) ? [...perguntasRespondidas] : [];

    let [perguntaRespodida] = perguntasRespondidasNew.filter(item => item.sessaoFormularioPerguntaId === sessaoFormularioPerguntaId);

    if (perguntaRespodida) {
      perguntaRespodida.respostas.push(opcaoResposta)
    } else {
      perguntaRespodida = {
        perguntaId,
        sessaoFormularioPerguntaId,
        pergunta,
        respostas: [opcaoResposta]
      }

      perguntasRespondidasNew.push(perguntaRespodida)
    }
    state.perguntasRespondidas = perguntasRespondidasNew
  },

  LIMPAR_RESPOSTAS_PERGUNTA: (state, payload) => {
    const { perguntasRespondidas } = state;
    const sessaoFormularioPerguntaId = payload;
    if (perguntasRespondidas && perguntasRespondidas.length) {


      const indexPerguntaRemover = perguntasRespondidas
        .findIndex(p => p.sessaoFormularioPerguntaId == sessaoFormularioPerguntaId);

      if (indexPerguntaRemover >= 0)
        perguntasRespondidas.splice(indexPerguntaRemover, 1);
    }

    state.perguntasRespondidas = perguntasRespondidas
  },
  REMOVER_RESPOSTA_PERGUNTA: (state, payload) => {
    let {
      perguntasRespondidas
    } = state;
    const {
      perguntaId,
      opcaoRespostaId
    } = payload;

    let [pergunta] = perguntasRespondidas.filter(item => item.perguntaId === perguntaId);

    if (pergunta && pergunta.respostas) {
      //remover a opcao de resposta
      const indexResposta = pergunta.respostas.findIndex(o => o.opcaoRespostaId == opcaoRespostaId);

      if (indexResposta >= 0)
        pergunta.respostas.splice(indexResposta, 1)
    }

    const respostas = [...pergunta.respostas]
    if (respostas && !respostas.length) {
      perguntasRespondidas = perguntasRespondidas.filter(p => p.perguntaId != perguntaId)

    }

    state.perguntasRespondidas = perguntasRespondidas

  },
  ADD_RESTRICAO_PRE_VALIDACAO: (state, payload) => {

    const existePerguntaPreValidacao = state.restricoesPreValidacao.includes(payload);
    if (!existePerguntaPreValidacao)
      state.restricoesPreValidacao.push(payload)
  },

  REMOVER_RESTRICAO_PRE_VALIDACAO: (state, payload) => {
    const {
      restricoesPreValidacao
    } = state;
    const novoStateRestricaoPreValidacao = restricoesPreValidacao.filter(codigoRestricao => codigoRestricao != payload);
    state.restricoesPreValidacao = novoStateRestricaoPreValidacao;
  },
  VERIFICAR_ENCADEAMENTO_PERGUNTA: (state, payload) => {

    if(window.__isDebugMode__)
      console.log('VERIFICAR_ENCADEAMENTO_PERGUNTA')

    const {
      perguntaId: perguntaPaiId,
      codigoTipoResposta,
      opcaoRespostaId,
      ecadeamentoPerguntas,
      ordemExibicao: ordemExibicaoPerguntaPai,
      sessaoFormularioId,
      sessaoFormularioPerguntaId /* o encadeamento da pergunta que deu origem a ação*/,
      valor,
      checked
    } = payload;



    const { formulario } = state;
    const novoFormulario = { ...formulario };
    const { sessoesFormulario } = novoFormulario;
    let perguntas = [];

    sessoesFormulario.map(sessao => sessao.perguntas.map(pergunta => perguntas.push(pergunta)));

    const [sessaoFormulario] = sessoesFormulario.filter(sessao => sessao.id == sessaoFormularioId);


    const perguntasEncadeadas = ecadeamentoPerguntas && ecadeamentoPerguntas.filter(ep => ep.opcaoRespostaId == opcaoRespostaId) || [];
    const [perguntaEncadeadaSelecionada] = perguntasEncadeadas.filter(pe => pe.opcaoRespostaId == opcaoRespostaId);
    let sessaoFormularioPerguntaFilhoIdRef = (perguntaEncadeadaSelecionada && perguntaEncadeadaSelecionada.sessaoFormularioPerguntaFilhoId) ? perguntaEncadeadaSelecionada.sessaoFormularioPerguntaFilhoId : null;

    //Atualização:
    /**
     * Inicialmente a configuração para mostrar uma subpergunta era 1 pra 1 ou seja uma opção de resposta habilitava uma subpergunta
     * foi necessário configurar que mais de uma opção de resposta mostrar uma mesma subpergunta então foi verificado
     * se sessaoFormularioPerguntaFilhoIdRef da uma opção selecionada é igual as das perguntas encadeadas que seriam ocultadas
     */
    let perguntasEncadeadasEsconder = [];
    let estaRemovendoPerguntaEncadeada =false;
    if (codigoTipoResposta != tipoResposta.CHECKBOX_VERTICAL) {
      perguntasEncadeadasEsconder = ecadeamentoPerguntas && (ecadeamentoPerguntas.filter(ep => ep.opcaoRespostaId != opcaoRespostaId) || [])
        .filter(ep => ep.sessaoFormularioPerguntaFilhoId != sessaoFormularioPerguntaFilhoIdRef || sessaoFormularioPerguntaFilhoIdRef == null);
    }

    // quando for um checkbox mandar essa flag junto com o valor checked
    if (codigoTipoResposta == tipoResposta.CHECKBOX_VERTICAL ) {

      if(checked == false)
      {
        perguntasEncadeadasEsconder = ecadeamentoPerguntas.filter(ep => ep.opcaoRespostaId == opcaoRespostaId);
        estaRemovendoPerguntaEncadeada = perguntasEncadeadasEsconder.length > 0;
      }

    }

    let novaOrdem = 0;


    //estaRemovendoPerguntaEncadeada = false; // revalidar esta flag

    //verificar se a pergunta corrente tem perguntas encadeadas
    if (perguntasEncadeadas && perguntasEncadeadas.length && !estaRemovendoPerguntaEncadeada) {

      //totalPerguntasVisiveis  = totalPerguntasVisiveis>0 ? totalPerguntasVisiveis : 1;
      let contadorPerguntas = 1;
      perguntasEncadeadas.map(perguntaEncadeada => {

        const [novaPergunta] = sessaoFormulario.perguntas.filter(pergunta => pergunta.sessaoFormularioPerguntaId == perguntaEncadeada.sessaoFormularioPerguntaFilhoId);

        if (novaPergunta) {
         
          novaPergunta.visivel = true;


          //pegar a sub-pergunta e colocar abaixo da pergunta pai no array de perguntas
          var indexPerguntaPai = sessaoFormulario.perguntas.findIndex(p => p.sessaoFormularioPerguntaId == sessaoFormularioPerguntaId);
          let indexSubPergunta = sessaoFormulario.perguntas.findIndex(p => p.sessaoFormularioPerguntaId == novaPergunta.sessaoFormularioPerguntaId);


          //atualizar o index da subpergunta
          //indexSubPergunta = sessaoFormulario.perguntas.findIndex(p => p.sessaoFormularioPerguntaId == pergunta.sessaoFormularioPerguntaId);
          let totalPerguntasVisiveis = sessaoFormulario.perguntas.filter (p=> p.sessaoFormularioPerguntaPaiId ==  sessaoFormularioPerguntaId && p.visivel).length;

          if(totalPerguntasVisiveis<=0) 
            totalPerguntasVisiveis=1;

          novaOrdem = ordemExibicaoPerguntaPai + totalPerguntasVisiveis;

          sessaoFormulario.perguntas
            .filter((perguntaVisivel,index) => perguntaVisivel.visivel && perguntaVisivel.ordemExibicao >= novaOrdem)
            .map(perguntaVisivel => perguntaVisivel.ordemExibicao += 1)

         
            novaPergunta.ordemExibicao = novaOrdem

        }
        contadorPerguntas++;

      })


    }

    if (perguntasEncadeadasEsconder && perguntasEncadeadasEsconder.length) {

      perguntasEncadeadasEsconder.map(perguntaEncadeada => {

        const [sessaoFormulario] = sessoesFormulario.filter(sessao => sessao.id == sessaoFormularioId)

        const [pergunta] = sessaoFormulario.perguntas
          .filter(pergunta => pergunta.sessaoFormularioPerguntaId == perguntaEncadeada.sessaoFormularioPerguntaFilhoId)
          .filter(pergunta => pergunta.visivel);

        if (pergunta) {
          pergunta.visivel = false;

          let totalPerguntasVisiveis = sessaoFormulario.perguntas.filter (p=> p.sessaoFormularioPerguntaPaiId ==  sessaoFormularioPerguntaId && p.visivel).length;
          

          novaOrdem = totalPerguntasVisiveis - 1;

          //let perguntasRemoverResposta = [pergunta.perguntaId];
          let perguntasRemoverResposta = [pergunta.sessaoFormularioPerguntaId];

          sessaoFormulario.perguntas
            .filter(perguntaRemover => perguntaRemover.sessaoFormularioPerguntaPaiId == pergunta.sessaoFormularioPerguntaId)
            .forEach(perguntaRemover => {
              perguntaRemover.visivel = false;
              perguntasRemoverResposta.push(perguntaRemover.sessaoFormularioPerguntaId);
            });

          if (perguntasRemoverResposta.length)
            perguntasRemoverResposta.forEach(sessaoFormularioPerguntaId => formularioMutation.LIMPAR_RESPOSTAS_PERGUNTA(state, sessaoFormularioPerguntaId));

          var indexPerguntaPai = sessaoFormulario.perguntas.findIndex(p => p.sessaoFormularioPerguntaId == sessaoFormularioPerguntaId);
          let indexSubPergunta = sessaoFormulario.perguntas.findIndex(p => p.sessaoFormularioPerguntaId == pergunta.sessaoFormularioPerguntaId);
          sessaoFormulario.perguntas
            //.filter((p, index) => p.visivel && index > indexPerguntaPai)
            .filter((perguntaVisivel,index) => perguntaVisivel.visivel && perguntaVisivel.ordemExibicao > pergunta.ordemExibicao)
            .map(p => p.ordemExibicao -= 1)

        }

        //novaOrdem++;
        //contadorPerguntas++;

      })

    }


    //variavel para limpar perguntas respondidas
    const perguntasRespondidasLimpar = [];


    state.formulario = novoFormulario;
    if (perguntasRespondidasLimpar && perguntasRespondidasLimpar.length) {
      perguntasRespondidasLimpar.forEach(perguntaLimpar => formularioMutation.LIMPAR_RESPOSTAS_PERGUNTA(state, perguntaLimpar))
    }

  }
}

export default formularioMutation;



// WEBPACK FOOTER //
// ./src/store/mutations/formulario.mutations.js